import Toastr from 'toastr2'
import 'toastr2/dist/toastr.min.css'

const toastr = new Toastr({
    closeButton: true,
    closeMethod: 'fadeOut',
    closeEasing: 'swing',
    preventDuplicates: true,
    progressBar: true,
    closeDuration:300,
    timeOut: 3000
})

export default toastr
